module.exports = __webpack_public_path__ + "img/icon_wave_w.e4ca7bdd.svg";